<template>
    <div>
        <v-container>
          <v-card-actions row wrap>
            <v-spacer></v-spacer>
            <v-flex xs12 sm12 md12>
              <v-card-title class="main-sect-title">
                <h1 class="tabHeader"> {{$t('settings.categories')}}</h1>
              </v-card-title>
              <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <category-ordering v-if="categories.length > 0"
                                   :categories = categories
                ></category-ordering>
                <v-dialog v-model="addCategoryDialog" max-width="550px">
                  <v-btn slot="activator" :ripple="false" class="send-request-btn">{{$t('settings.add')}}</v-btn>
                  <v-card class="add-new-category-modal">
                    <v-card-title class="close-modal-btn-sect">
                      <v-btn :ripple="false" class="close-modal-x-btn" flat @click="closeAddCategoryDialog">
                        <v-icon>icon-cancel</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-title class="headline-title">
                      <span>{{$t('settings.new_category')}}</span>
                    </v-card-title>
                    <v-card-text class="text-sect">
                      <v-container grid-list-md>
                        <v-layout wrap class="text-field-and-textarea-sect">
                          <v-flex xs12 sm6 md4 class="text-field-sect">
                            <v-text-field
                              v-model="newCategoryData.name"
                              :label="$t('settings.name')"
                              class="new-category-input"
                              solo
                              flat
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md4 class="textarea-sect">
                            <v-textarea
                              v-model="newCategoryData.description"
                              :label="$t('settings.description')"
                              color = 'indigo accent-4'
                              flat
                              class="new-category-textarea"
                              solo
                              :no-resize="true"
                              rows="4">
                            </v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions class="add-cancel-btn-sect">
                      <v-btn flat class="cancel-new-category-btn" @click="closeAddCategoryDialog">{{$t('close')}}</v-btn>
                      <v-btn flat class="add-new-category-btn" @click="addCategory">{{$t('settings.add')}}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="editCategoryDialog" max-width="550px">
                  <v-card class="add-new-category-modal">
                    <v-card-title class="close-modal-btn-sect">
                      <v-btn :ripple="false" class="close-modal-x-btn" flat @click="closeEditCategoryDialog">
                        <v-icon>icon-cancel</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-title class="headline-title">
                      <span>{{$t('settings.edit_category')}}</span>
                    </v-card-title>
                    <v-card-text class="text-sect">
                      <v-container grid-list-md>
                        <v-layout wrap class="text-field-and-textarea-sect">
                          <v-flex xs12 sm6 md4 class="text-field-sect">
                            <v-text-field
                              v-model="editCategoryData.name"
                              solo
                              flat
                              class="new-category-input"
                              :label="$t('settings.name')">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md4 class="textarea-sect">
                            <v-textarea
                              v-model="editCategoryData.description"
                              :label="$t('settings.description')"
                              flat
                              class="new-category-textarea"
                              solo
                              :no-resize="true"
                              color = 'indigo accent-4'
                              rows="4">
                            </v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions class="add-cancel-btn-sect">
                      <v-btn :ripple="false" class="cancel-new-category-btn" flat @click="closeEditCategoryDialog">{{$t('close')}}</v-btn>
                      <v-btn :ripple="false" class="add-new-category-btn" flat @click="editCategory">{{$t('settings.update')}}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="categoriesTableSearch"
                  append-icon="search"
                  :label="$t('settings.search')"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table ref="category"
                :headers="categoriesTableHeaders"
                :items="categories"
                :search="categoriesTableSearch"
                hide-headers
              >
                <template slot="items" slot-scope="props">
                  <td @click="selectCategory(props.item)" :class=" (selectedCategory && selectedCategory.id === props.item.id) ? 'active-category need-pointer' : 'need-pointer'">{{ props.item.displayInfo.name }}</td>
                  <td>{{ props.item.displayInfo.description }}</td>
                  <td class="justify-center layout px-0">
                    <v-icon v-if="props.item.subcategories.length === 0"
                            small
                            class="mr-2 need-pointer"
                            @click="changeCategoryVisibility(props.item)"
                    >
                      {{ props.item.active ?  'icon-view-2' : 'icon-view-1'}}
                    </v-icon>
                    <v-icon v-if="props.item.subcategories.length === 0"
                            small
                            class="mr-2 need-pointer"
                            @click="changeCategoryStatus(props.item)"
                    >
                      check_circle
                    </v-icon>
                    <v-icon
                      small
                      class="mr-2 need-pointer"
                      @click="openEditCategoryDialog(props.item)"
                    >
                      edit
                    </v-icon>
                    <v-icon v-if="props.item.subcategories.length === 0"
                            small
                            class="need-pointer"
                            @click="deleteCategory(props.item)"
                    >
                      delete
                    </v-icon>
                  </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  {{$t('settings.no_result_for_search')}} "{{ categoriesTableSearch }}"
                </v-alert>
              </v-data-table>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm12 md12 v-if="selectedCategory">
              <v-toolbar flat color="white">
                <v-toolbar-title class="toolbar-title">{{$t('settings.subcategories')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <category-ordering v-if="subCategories.length > 0"
                                   :categories = subCategories
                                   :key="selectedCategory.id"
                ></category-ordering>
                <v-dialog v-model="addSubCategoryDialog" max-width="550px">
                  <v-btn slot="activator" :ripple="false" class="send-request-btn">{{$t('settings.add')}}</v-btn>
                  <v-card>
                    <v-card-title class="close-modal-btn-sect">
                      <v-btn :ripple="false" class="close-modal-x-btn" flat @click="closeAddSubCategoryDialog">
                        <v-icon>icon-cancel</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-title class="headline-title">
                      <span>{{$t('settings.new_category')}}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap align-center column class="add-subcategory-main-sect">
                          <v-flex xs12 sm4 md4 class="add-subcategory-sect">
                            <v-select
                              :items="categories"
                              v-model="subCategoryParent"
                              :label="$t('settings.category')"
                              item-text="displayInfo.name"
                              item-value="id"
                              @input="selectSubCategoryParent"
                              single-line
                              attach=".add-subcategory-sect"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm4 md4 class="text-field-sect">
                            <v-text-field
                              v-model="newSubCategoryData.name"
                              :label="$t('settings.name')"
                              flat solo
                              class="new-category-input"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm4 md4 class="textarea-sect other-category-textarea">
                            <v-textarea
                              v-model="newSubCategoryData.description"
                              :label="$t('settings.description')"
                              color = 'indigo accent-4'
                              flat
                              class="new-category-textarea"
                              solo
                              :no-resize="true"
                              rows="4">
                            </v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>

                    <v-card-actions class="add-cancel-btn-sect">
                      <v-btn  :ripple="false" flat class="cancel-new-category-btn" @click="closeAddSubCategoryDialog">{{$t('close')}}</v-btn>
                      <v-btn  :ripple="false" class="add-new-category-btn" flat @click="addSubCategory">{{$t('settings.add')}}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="editSubCategoryDialog" max-width="550px">
                  <v-card>
                    <v-card-title class="close-modal-btn-sect">
                      <v-btn :ripple="false" class="close-modal-x-btn" flat @click="closeEditSubCategoryDialog">
                        <v-icon>icon-cancel</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-title class="headline-title">
                      <span>{{$t('settings.edit_category')}}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap align-center column class="add-subcategory-main-sect">
                          <v-flex xs12 sm4 md4  class="edit-subcategory-sect">
                            <v-select
                              :items="categories"
                              v-model="subCategoryParent"
                              :label="$t('settings.category')"
                              item-text="displayInfo.name"
                              item-value="id"
                              @input="selectSubCategoryParent"
                              single-line
                              clearable
                              attach=".edit-subcategory-sect"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm4 md4 class="text-field-sect">
                            <v-text-field
                              v-model="editSubCategoryData.name"
                              :label="$t('settings.name')"
                              flat solo
                              class="new-category-input"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm4 md4 class="textarea-sect other-category-textarea">
                            <v-textarea
                              v-model="editSubCategoryData.description"
                              :label="$t('settings.description')"
                              color = 'indigo accent-4'
                              flat
                              class="new-category-textarea"
                              solo
                              :no-resize="true"
                              rows="4">
                            </v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions class="add-cancel-btn-sect">
                      <v-btn  :ripple="false" flat class="cancel-new-category-btn" @click="closeEditSubCategoryDialog">{{$t('close')}}</v-btn>
                      <v-btn :ripple="false" class="add-new-category-btn" flat @click="editSubCategory">{{$t('settings.update')}}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="subCategoriesTableSearch"
                  append-icon="search"
                  :label="$t('settings.search')"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="subCategoriesTableHeaders"
                :items="subCategories"
                :search="subCategoriesTableSearch"
                hide-headers
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.displayInfo.name }}</td>
                  <td>{{ props.item.displayInfo.description }}</td>
                  <td class="justify-center layout px-0">
                    <v-icon
                      small
                      class="mr-2 need-pointer"
                      @click="changeCategoryVisibility(props.item)"
                    >
                      {{ props.item.active ?  'icon-view-2' : 'icon-view-1'}}
                    </v-icon>
                    <v-icon
                      small
                      class="mr-2 need-pointer"
                      @click="openEditSubCategoryDialog(props.item)"
                    >
                      edit
                    </v-icon>
                    <v-icon
                      small
                      class="need-pointer"
                      @click="deleteSubCategory(props.item)"
                    >
                      delete
                    </v-icon>
                  </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  {{$t('settings.no_result_for_search')}} "{{ subCategoriesTableSearch }}"
                </v-alert>
              </v-data-table>
            </v-flex>
          </v-card-actions>
        </v-container>

        <v-container>
          <v-flex xs12 sm12 md12 v-if="otherCategories.length > 0">
            <v-toolbar flat color="white">
              <v-toolbar-title class="toolbar-title">{{$t('settings.other_categories')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-dialog v-model="editOtherCategoryDialog" max-width="550px">
                <v-card class="add-other-category-sect">
                  <v-card-title class="close-modal-btn-sect">
                    <v-btn :ripple="false" class="close-modal-x-btn" flat @click="closeEditOtherCategoryDialog">
                      <v-icon>icon-cancel</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text class="text-sect other-categories">
                    <v-tabs
                      v-model="editOtherCategoryDialogActiveTab"
                    >
                      <v-tab key="edit" :ripple="false">
                        {{$t('edit')}}
                      </v-tab>
                      <v-tab key="merge" :ripple="false">
                        {{$t('merge')}}
                      </v-tab>
                      <v-tab-item key="edit">
                        <v-card flat class="edit-other-category-sect">
                          <v-card-text>
                            <v-container grid-list-md>
                              <v-layout wrap align-center column>
                                <v-flex xs12 sm4 md12 class="other-category-select-element" >
                                  <v-select
                                    :items="categories"
                                    v-model="otherCategoryParent"
                                    :label="$t('settings.category')"
                                    item-text="displayInfo.name"
                                    item-value="id"
                                    @input="selectOtherCategoryParent"
                                    single-line
                                    clearable
                                    class="select-other-categoty"
                                    attach=".other-category-select-element"
                                  ></v-select>
                                </v-flex>
                                <v-flex xs12 sm4 md4 class="text-field-sect">
                                  <v-text-field
                                    v-model="editOtherCategoryData.name"
                                    :label="$t('settings.name')"
                                    flat solo
                                    class="new-category-input"
                                  >
                                  </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm4 md4 class="textarea-sect other-category-textarea">
                                  <v-textarea
                                    v-model="editOtherCategoryData.description"
                                    :label="$t('settings.description')"
                                    color = 'indigo accent-4'
                                    flat
                                    class="new-category-textarea"
                                    solo
                                    :no-resize="true"
                                    rows="4">
                                  </v-textarea>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item key="merge">
                        <v-card flat>
                          <v-card-text class="other-category-select-element merge-sect-one">
                            <v-select
                              :items="categories"
                              v-model="otherCategoryMergeItem"
                              :label="$t('settings.category')"
                              item-text="displayInfo.name"
                              item-value="id"
                              @input="selectOtherCategoryMergeItem"
                              :no-data-text="$t('no_data_available')"
                              single-line
                              attach=".merge-sect-one"
                            ></v-select>
                          </v-card-text>
                          <v-card-text class="second-merge-sect">
                            <v-select
                              :items="otherSubCategoryMergeItems"
                              v-model="otherSubCategoryMergeItem"
                              :label="$t('settings.subcategories')"
                              item-text="displayInfo.name"
                              item-value="id"
                              @input="selectOtherSubCategoryMergeItem"
                              :no-data-text="$t('no_data_available')"
                              single-line
                              attach=".second-merge-sect"
                            ></v-select>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs>
                  </v-card-text>
                  <v-card-actions class="add-cancel-btn-sect">
                    <v-btn  :ripple="false" flat class="cancel-new-category-btn" @click="closeEditOtherCategoryDialog">{{$t('close')}}</v-btn>
                    <v-btn  :ripple="false" class="add-new-category-btn" flat @click="editOtherCategory">{{$t('save')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="otherCategoriesTableSearch"
                append-icon="search"
                :label="$t('settings.search')"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="otherCategoriesTableHeaders"
              :items="otherCategories"
              :search="otherCategoriesTableSearch"
              hide-headers
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.displayInfo.name }}</td>
                <td>{{ props.item.displayInfo.description }}</td>
                <td class="justify-center layout px-0">
                  <v-icon
                    small
                    class="mr-2 need-pointer"
                    @click="changeCategoryVisibility(props.item)"
                  >
                    {{ props.item.active ?  'icon-view-2' : 'icon-view-1'}}
                  </v-icon>
                  <v-icon
                    small
                    class="mr-2 need-pointer"
                    @click="changeCategoryStatus(props.item)"
                  >
                    check_circle
                  </v-icon>
                  <v-icon
                    small
                    class="mr-2 need-pointer"
                    @click="openEditOtherCategoryDialog(props.item)"
                  >
                    edit
                  </v-icon>
                  <v-icon
                    small
                    class="need-pointer"
                    @click="deleteOtherCategory(props.item)"
                  >
                    delete
                  </v-icon>
                </td>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                {{$t('settings.no_result_for_search')}} "{{ otherCategoriesTableSearch }}"
              </v-alert>
            </v-data-table>
          </v-flex>
        </v-container>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import {EventBus} from '../../../event-bus'
import CategoryOrdering from '../../modals/CategoryOrdering'
const getSettings = function (settings, lang) {
  let _settings = []
  if (settings) {
    settings.forEach(setting => {
      setting.SettingTranslations.forEach(st => {
        if (!setting.value) {
          setting.value = st.value
        }
        if (st.languageId === lang.id) {
          setting.value = st.value
        }
      })
      _settings.push(setting)
    })
  }
  return _settings
}
export default {
  name: 'ProductCategory',
  components: {
    CategoryOrdering
  },
  data: () => ({
    active: null,
    settings: [],
    categoriesTableSearch: '',
    categories: [],
    addCategoryDialog: false,
    editCategoryDialog: false,
    newCategoryData: {},
    editCategoryData: {},
    selectedCategory: null,

    subCategoriesTableSearch: '',
    subCategories: [],
    addSubCategoryDialog: false,
    editSubCategoryDialog: false,
    newSubCategoryData: {},
    editSubCategoryData: {},
    subCategoryParent: null,

    otherCategoriesTableSearch: '',
    otherCategories: [],
    addOtherCategoryDialog: false,
    editOtherCategoryDialog: false,
    newOtherCategoryData: {},
    editOtherCategoryData: {},
    otherCategoryParent: null,
    editOtherCategoryDialogActiveTab: 0,
    otherCategoryMergeItem: null,
    otherSubCategoryMergeItem: null,
    otherSubCategoryMergeItems: [],
    count: '',
    show: false
  }),
  computed: {
    ...mapState({
      activeLanguage: state => state.common.activeLanguage
    }),
    categoriesTableHeaders () {
      return [
        { text: this.$t('settings.name'), align: 'left', sortable: false, value: 'displayInfo.name' },
        { text: this.$t('settings.description'), align: 'left', sortable: false, value: 'displayInfo.description' },
        { text: this.$t('settings.actions'), align: 'left', sortable: false, value: '' }
      ]
    },
    subCategoriesTableHeaders () {
      return [
        { text: this.$t('settings.name'), align: 'left', sortable: false, value: 'displayInfo.name' },
        { text: this.$t('settings.description'), align: 'left', sortable: false, value: 'displayInfo.description' },
        { text: this.$t('settings.actions'), align: 'left', sortable: false, value: '' }
      ]
    },
    otherCategoriesTableHeaders () {
      return [
        { text: this.$t('settings.name'), align: 'left', sortable: false, value: 'displayInfo.name' },
        { text: this.$t('settings.description'), align: 'left', sortable: false, value: 'displayInfo.description' },
        { text: this.$t('settings.actions'), align: 'left', sortable: false, value: '' }
      ]
    }
  },
  methods: {
    languageChanged (lang) {
      this.settings = getSettings(this.settings, lang)
      this.categoriesWithSubCategories()
    },
    updateSettings () {
      let data = []
      this.settings.forEach(setting => {
        data.push({id: setting.id, value: setting.value, languageId: this.activeLanguage.id})
      })
      if (data.length > 0) {
        this.$store.dispatch('common/updateSettings', {data: data})
          .then((res) => {
            this.settings = getSettings(res.data.settings, this.activeLanguage)
            this.$toastr(res.data.type, res.data.message, this.$t(res.data.type))
          })
          .catch(console.error)
      }
    },
    addCategory () {
      this.$store.dispatch('categories/add', this.newCategoryData)
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
          if (res.type === 'success') {
            this.addCategoryDialog = false
          }
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    openEditCategoryDialog (category) {
      this.editCategoryData = {
        id: category.id,
        name: category.displayInfo.name,
        description: category.displayInfo.description
      }
      this.editCategoryDialog = true
    },
    editCategory () {
      this.$store.dispatch('categories/edit', this.editCategoryData)
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
          if (res.type === 'success') {
            this.editCategoryDialog = false
          }
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    deleteCategory (category) {
      const txt = `${this.$t('settings.confirm_delete_item')} "${category.displayInfo.name}"`
      if (!confirm(txt)) {
        return false
      }

      this.$store.dispatch('categories/delete', {categoryId: category.id})
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    closeAddCategoryDialog () {
      this.addCategoryDialog = false
    },
    closeEditCategoryDialog () {
      this.editCategoryDialog = false
    },
    selectCategory (category) {
      this.selectedCategory = category
      this.subCategoryParent = category
      this.otherCategoryParent = category
      this.subCategories = category.subcategories
    },
    categoriesWithSubCategories () {
      this.$store.dispatch('categories/listWithSubCategoriesForAdmin')
        .then((res) => {
          let _categories = []
          let _subCategories = []
          let _otherCategories = []

          if (res && res.categories && res.categories.length > 0) {
            res.categories.forEach((cat) => {
              if (cat.status === 1 && cat.needCategory !== true) { // 1 = active status
                if (this.selectedCategory && this.selectedCategory.id === cat.id) {
                  if (cat.subcategories && cat.subcategories.length > 0) {
                    cat.subcategories.forEach((subCat) => {
                      if (subCat.status === 1) { // 1 = active status
                        _subCategories.push(subCat)
                      } if (subCat.status === 0) { // 0 = inactive
                        _otherCategories.push(subCat)
                      }
                    })
                  }
                  this.selectedCategory = cat
                  this.subCategoryParent = cat
                }
                _categories.push(cat)
              } else if (cat.status === 0) { // 0 = inactive
                _otherCategories.push(cat)
              }
            })
          }
          this.categories = _categories
          this.subCategories = _subCategories
          this.otherCategories = _otherCategories
        })
        .catch(console.error)
    },
    selectSubCategoryParent (categoryId) {
      const parentCategoryItem = this.categories.filter((cat) => cat.id === categoryId)
      this.subCategoryParent = parentCategoryItem && parentCategoryItem[0]
    },
    addSubCategory () {
      this.newSubCategoryData.parentId = this.subCategoryParent && this.subCategoryParent.id
      this.$store.dispatch('categories/add', this.newSubCategoryData)
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
          if (res.type === 'success') {
            this.addSubCategoryDialog = false
          }
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    openEditSubCategoryDialog (category) {
      this.editSubCategoryData = {
        id: category.id,
        name: category.displayInfo.name,
        description: category.displayInfo.description
      }
      this.selectSubCategoryParent(category.parentId)
      this.editSubCategoryDialog = true
    },
    editSubCategory () {
      this.editSubCategoryData.parentId = (this.subCategoryParent && this.subCategoryParent.id) ? this.subCategoryParent.id : null
      this.$store.dispatch('categories/edit', this.editSubCategoryData)
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
          if (res.type === 'success') {
            this.editSubCategoryDialog = false
          }
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    deleteSubCategory (category) {
      const txt = `${this.$t('settings.confirm_delete_item')} "${category.displayInfo.name}"`
      if (!confirm(txt)) {
        return false
      }

      this.$store.dispatch('categories/delete', {categoryId: category.id})
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    closeAddSubCategoryDialog () {
      this.addSubCategoryDialog = false
    },
    closeEditSubCategoryDialog () {
      this.editSubCategoryDialog = false
    },
    selectOtherCategoryParent (categoryId) {
      const parentCategoryItem = this.categories.filter((cat) => cat.id === categoryId)
      this.otherCategoryParent = parentCategoryItem && parentCategoryItem[0]
    },
    selectOtherCategoryMergeItem (categoryId) {
      const parentCategoryItem = this.categories.filter((cat) => cat.id === categoryId)
      this.otherCategoryMergeItem = parentCategoryItem && parentCategoryItem[0]
      this.otherSubCategoryMergeItem = null
      this.otherSubCategoryMergeItems = this.otherCategoryMergeItem && this.otherCategoryMergeItem.subcategories
    },
    selectOtherSubCategoryMergeItem (categoryId) {
      const parentCategoryItem = this.otherSubCategoryMergeItems.filter((cat) => cat.id === categoryId)
      this.otherSubCategoryMergeItem = parentCategoryItem && parentCategoryItem[0]
    },
    openEditOtherCategoryDialog (category) {
      this.editOtherCategoryData = {
        id: category.id,
        name: category.displayInfo.name,
        description: category.displayInfo.description
      }
      this.editOtherCategoryDialog = true
    },
    editOtherCategory () {
      if (this.editOtherCategoryDialogActiveTab === 0) { // Edit
        this.editOtherCategoryData.parentId = this.otherCategoryParent && this.otherCategoryParent.id
        this.editOtherCategoryData.otherCategory = true
        this.$store.dispatch('categories/edit', this.editOtherCategoryData)
          .then((res) => {
            this.$toastr(res.type, res.message, this.$t(res.type))
            if (res.type === 'success') {
              this.editOtherCategoryDialog = false
            }
          })
          .then(() => {
            this.categoriesWithSubCategories()
          })
          .catch(console.error)
      } else if (this.editOtherCategoryDialogActiveTab === 1) { // Merge
        const mergeData = {
          id: this.editOtherCategoryData.id,
          categoryId: this.otherSubCategoryMergeItem ? this.otherSubCategoryMergeItem.id : (this.otherCategoryMergeItem && this.otherCategoryMergeItem.id)
        }

        this.$store.dispatch('categories/mergeCategory', mergeData)
          .then((res) => {
            this.$toastr(res.type, res.message, this.$t(res.type))
            if (res.type === 'success') {
              this.editOtherCategoryDialog = false
            }
          })
          .then(() => {
            this.categoriesWithSubCategories()
          })
          .catch(console.error)
      } else {
        this.$toastr('error', this.$t('something_wrong'), this.$t('error'))
        this.editOtherCategoryDialog = false
      }
    },
    deleteOtherCategory (category) {
      const txt = `${this.$t('settings.confirm_delete_item')} "${category.displayInfo.name}"`
      if (!confirm(txt)) {
        return false
      }

      this.$store.dispatch('categories/delete', {categoryId: category.id})
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    changeCategoryStatus (category) {
      const txt = `${this.$t('settings.confirm_change_category_status')} "${category.displayInfo.name}"`
      if (!confirm(txt)) {
        return false
      }
      const status = category.status === 0 ? 1 : 0

      this.$store.dispatch('categories/changeStatus', {categoryId: category.id, status: status})
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    changeCategoryVisibility (category) {
      const txt = `${this.$t('settings.confirm_change_category_visibility')} "${category.displayInfo.name}"`
      if (!confirm(txt)) {
        return false
      }
      const active = category.active === 0 ? 1 : 0
      this.$store.dispatch('categories/changeVisibility', {categoryId: category.id, active: active})
        .then((res) => {
          this.$toastr(res.type, res.message, this.$t(res.type))
        })
        .then(() => {
          this.categoriesWithSubCategories()
        })
        .catch(console.error)
    },
    closeEditOtherCategoryDialog () {
      this.editOtherCategoryDialog = false
    }
  },
  created () {
    this.$store.dispatch('common/getSettings')
      .then((res) => {
        if (res.data && res.data.settings) {
          this.settings = getSettings(res.data.settings, this.activeLanguage)
        }
      })
      .catch(console.error)
    this.categoriesWithSubCategories()
    EventBus.$on('language-changed', this.languageChanged)
  },
  mounted () {
    this.$refs.category.$el.querySelector('.v-table__overflow').addEventListener('touchstart', function (ev) {
      ev.stopPropagation()
    })
    this.$refs.category.$el.querySelector('.v-table__overflow').addEventListener('touchend', function (ev) {
      ev.stopPropagation()
    })
  }
}
</script>

<style lang="scss" scoped>
                   .toolbar-title {
                     @media (max-width: 400px) {
                       font-size: 14px;
                     }
                   }
@import "../../../assets/sass/desktop/mySetting.scss";
  @import "../../../assets/sass/desktop/analyticsPage.scss";
</style>



// WEBPACK FOOTER //
// src/components/profilePage/components/ProductCategory.vue